// src/pages/PersonalPage.js
import React, { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function PersonalPage() {
  const { isAdmin } = useAuth();
  const [personal, setPersonal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [importMsg, setImportMsg] = useState(null);
  const [filters, setFilters] = useState({ q: '', area: '', cargo: '', sexo: '' });

  const fetchPersonal = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams(Object.fromEntries(Object.entries(filters).filter(([,v])=>v)));
    try {
      const res = await api.get(`/personal?${params}`);
      setPersonal(res.data.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, [filters]);

  useEffect(() => { fetchPersonal(); }, [fetchPersonal]);

  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('archivo', file);
    setImportMsg({ type: 'loading', text: 'Importando...' });
    try {
      const res = await api.post('/personal/importar', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      const r = res.data.resultados;
      setImportMsg({
        type: 'success',
        text: `✅ Importado: ${r.insertados} nuevos, ${r.actualizados} actualizados, ${r.errores.length} errores`,
        errores: r.errores,
      });
      fetchPersonal();
    } catch (err) {
      setImportMsg({ type: 'error', text: err.response?.data?.message || 'Error al importar' });
    }
    e.target.value = '';
  };

  const handleExport = async () => {
    const params = new URLSearchParams(Object.fromEntries(Object.entries(filters).filter(([,v])=>v)));
    try {
      const res = await api.get(`/personal/exportar?${params}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a'); a.href = url;
      a.download = `personal_macdesa_${Date.now()}.xlsx`;
      a.click(); window.URL.revokeObjectURL(url);
    } catch (err) { alert('Error al exportar'); }
  };

  const s = {
    title: { fontSize: 22, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 },
    card: { background: '#fff', borderRadius: 10, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,.08)', marginBottom: 16 },
    filters: { display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 },
    input: { padding: '7px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13 },
    // btn: (color='#d4940a') => ({ padding: '8px 16px', background: color, color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 }),
    btn: (color = '#d48806') => ({
                backgroundColor: color,
                color: '#fff',
                padding: '6px 15px',
                borderRadius: '4px',
                border: 'none',
                fontSize: '14px',
                cursor: 'pointer',
  
                // ESTO ES LO QUE SOLUCIONA EL ALINEAMIENTO
                display: 'inline-flex',   // Hace que el contenedor se ajuste al contenido
                alignItems: 'center',     // Centra verticalmente el contenido
                justifyContent: 'center', // Centra horizontalmente el contenido
                lineHeight: 'normal',     // Resetea alturas de línea extrañas
                height: '30px',           // Altura fija para que ambos midan EXACTAMENTE lo mismo -- era 34 originalmente
                boxSizing: 'border-box'   // Asegura que el padding no afecte la altura total
            }),
    msg: (type) => ({
      padding: '10px 14px', borderRadius: 8, marginBottom: 12, fontSize: 13,
      background: type==='success'?'#f6ffed':type==='error'?'#fff1f0':'#e6f7ff',
      border: `1px solid ${type==='success'?'#b7eb8f':type==='error'?'#ffa39e':'#91d5ff'}`,
    }),
  };

  return (
    <div>
      <div className="responsive-header" style={{ marginBottom: '10px' }}>
        <div>
          <div style={s.title}>👷 Maestro de Personal</div>
          <div style={{ color: '#888', fontSize: 13 }}>Registro de trabajadores – Total: {personal.length}</div>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <button style={s.btn('#52c41a')} onClick={handleExport}>
                  ⬇ Exportar Excel
              </button>
  
              {isAdmin && (
                  <>
                    <label style={{ ...s.btn('#d48806'), marginBottom: 0 }}> 
                        ⬆ Importar Excel
                        <input type="file" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={handleImport} />
                    </label>
                    <div style={{ ...s.card, marginBottom: 0, borderLeft: '4px solid #1890ff', padding: '6px 15px', fontSize: 12, display: 'flex', alignItems: 'center' }}>
                      📋 <b>Formato Excel requerido:</b> &nbsp;Columnas: DNI | APELLIDO PATERNO | APELLIDO MATERNO | NOMBRES | SEXO (M/F) | AREA | CARGO
                    </div>
                  </>
              )}
          </div>
      </div>

      {/* Mensaje importación */}
      {importMsg && (
        <div style={s.msg(importMsg.type)}>
          {importMsg.text}
          {importMsg.errores?.length > 0 && (
            <details style={{ marginTop: 6 }}>
              <summary>Ver errores ({importMsg.errores.length})</summary>
              {importMsg.errores.map((e, i) => <div key={i} style={{ fontSize: 11, color: '#a8071a' }}>Fila {e.fila}: {e.error}</div>)}
            </details>
          )}
        </div>
      )}

      {/* Filtros */}
      <div style={s.filters}>
        <input style={{ ...s.input, width: 200 }} placeholder="🔍 DNI o Nombre..." value={filters.q} onChange={e=>setFilters({...filters,q:e.target.value})} />
        <input style={s.input} placeholder="Área" value={filters.area} onChange={e=>setFilters({...filters,area:e.target.value})} />
        <input style={s.input} placeholder="Cargo" value={filters.cargo} onChange={e=>setFilters({...filters,cargo:e.target.value})} />
        <select style={s.input} value={filters.sexo} onChange={e=>setFilters({...filters,sexo:e.target.value})}>
          <option value="">Ambos sexos</option>
          <option value="M">Masculino</option>
          <option value="F">Femenino</option>
        </select>
      </div>

      {/* Tabla */}
      <div style={s.card}>
        <div className="responsive-table-container">
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                {['DNI','Apellido Paterno','Apellido Materno','Nombres','Sexo','Área','Cargo'].map(h => (
                  <th key={h} style={{ padding: '10px 12px', textAlign: 'left', borderBottom: '2px solid #e8e8e8', whiteSpace: 'nowrap', fontWeight: 600 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {personal.map(p => (
                <tr key={p.dni} style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <td style={{ padding: '8px 12px', fontFamily: 'monospace' }}>{p.dni}</td>
                  <td style={{ padding: '8px 12px' }}>{p.ape_paterno}</td>
                  <td style={{ padding: '8px 12px' }}>{p.ape_materno}</td>
                  <td style={{ padding: '8px 12px' }}>{p.nombres}</td>
                  <td style={{ padding: '8px 12px' }}>
                    <span style={{ padding:'2px 8px',borderRadius:10,fontSize:11,
                      background:p.sexo==='M'?'#e6f7ff':'#fff0f6',
                      color:p.sexo==='M'?'#0050b3':'#9e1068' }}>
                      {p.sexo === 'M' ? '♂ M' : '♀ F'}
                    </span>
                  </td>
                  <td style={{ padding: '8px 12px', color: '#666' }}>{p.area || '–'}</td>
                  <td style={{ padding: '8px 12px', color: '#666' }}>{p.cargo || '–'}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!loading && !personal.length && <div style={{ padding: 40, textAlign: 'center', color: '#aaa' }}>Sin registros</div>}
          {loading && <div style={{ padding: 20, textAlign: 'center' }}>⏳ Cargando...</div>}
        </div>
      </div>
    </div>
  );
}
